import React, { Fragment } from 'react';
import numeral from 'numeral';

import {
    Typography,
    Box,
    Grid,
    colors,
    makeStyles,
    Chip,
    Avatar,
    Button
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    labelvalue: {
        padding: 7
    },
    instrumenticon: {
        padding: 1,
        width: 120,
        height: 120
    },
    chipgreen: {
        backgroundColor: colors.grey[400],
        width: 110,
        margin: 4
    },
    chipblue: {
        backgroundColor: colors.grey[400],
        width: 110,
        margin: 4
    },
    chipred: {
        backgroundColor: colors.orange[600],
        width: 110,
        margin: 4,
        color: "#ffffff"
    },
    chipyellow: {
        backgroundColor: colors.yellow[900],
        width: 110,
        margin: 4,
        color: "#ffffff"
    }

}));


const INST08 = ({ instrument, message, event, instruments, alarm, device, schedules, commands, sendCommands }) => {

    const classes = useStyles();

    const getStateImage = (instrument, message, alarm) => {
        var alarmedin = false;
        var alarmedout = false;
        instrument.inputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedin && isAlarmedField(field, alarm)) {
                        alarmedin = true;
                    }
                }
            });
        });
        instrument.outputfields.map((infield) => {
            message.inputs.map((field) => {
                if (field.order === infield.fieldindex) {
                    if (!alarmedout && isAlarmedField(field, alarm)) {
                        alarmedout = true;
                    }
                }
            });
        });
        if (alarmedin && alarmedout) {
            return '/static/images/instruments/btn.jpg'
        } else if (alarmedin) {
            return '/static/images/instruments/btn.jpg'
        } else if (alarmedout) {
            return '/static/images/instruments/btn.jpg'
        } else {
            return '/static/images/instruments/btn.jpg'
        }
    }

    const isAlarmedField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.order == field.order && fail.type === 'fail') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    const isWarningField = (field, alarm) => {
        if (alarm === undefined || field === undefined) {
            return false;
        }
        if (Object.keys(alarm).length != 0) {
            var count = 0;
            alarm.fails.map((fail) => {
                if (fail.field.id == field._id && fail.type === 'warn') {
                    count++;
                }
            })
            return (count > 0);
        }
        return false
    }

    return (
        <Fragment>
            <Box padding={1} margin={instrument.border} border={instrument.border} borderRadius={instrument.radius}
                borderColor={colors.grey[300]}>

                <Typography color="textSecondary" variant="h5" className={classes.labelvalue}>
                    <b>{instrument.label}</b>
                </Typography>

                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="center"
                >

                    <Grid item xs="auto" key={instrument._id} >

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                {infield.label}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            {(commands.values[0] === 1) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={(commands.values[0] === 1) ? infield.on : infield.off} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={(commands.values[0] === 1) ? infield.on : infield.off} />

                                                ) : (
                                                    <Chip className={classes.chipblue}
                                                        size="small"
                                                        label={(commands.values[0] === 1) ? infield.on : infield.off} />

                                                )
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.inputfields.length)) ? (
                                    <Grid item xs="auto">
                                        <div>&nbsp;</div>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}

                    </Grid>

                    <Grid item xs="auto">
                        <Button
                            onClick={() => { sendCommands(commands, 0, commands.values[0]) }}>
                            <Avatar className={classes.instrumenticon} variant="rounded"
                                src={getStateImage(instrument, message, alarm)}>
                            </Avatar>
                        </Button>
                    </Grid>

                    <Grid item xs="auto">

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="center"
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}  >
                                                Comando Enviado
                                            </Typography>
                                        </Grid>
                                        <Grid item xs="auto">
                                            {(commands.values[0] === 1) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={(commands.values[0] === 1) ? 'Ligar' : 'Desligar'} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={(commands.values[0] === 1) ? 'Ligar' : 'Desligar'} />

                                                ) : (
                                                    <Chip className={classes.chipblue}
                                                        size="small"
                                                        label={(commands.values[0] === 1) ? 'Ligar' : 'Desligar'} />

                                                )
                                            )}
                                        </Grid>
                                    </Grid>
                                ) : (<div></div>)
                            ))
                        ))}


                        {instrument.outputfields.map((infield, index) => (
                            message.inputs.map((field, index) => (
                                (field.order === infield.fieldindex) ? (

                                    <Grid
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center"
                                        key={field._id}
                                    >
                                        <Grid item xs="auto">
                                            <Typography color="secondary" variant="body2" className={classes.labelvalue}>
                                                {infield.label}
                                            </Typography>
                                        </Grid>

                                        <Grid item xs="auto">

                                            {isAlarmedField(field, alarm) ? (
                                                <Chip className={classes.chipred}
                                                    size="small"
                                                    label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                            ) : (
                                                (isWarningField(field, alarm)) ? (
                                                    <Chip className={classes.chipyellow}
                                                        size="small"
                                                        label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                                ) : (

                                                    <Chip className={classes.chipgreen}
                                                        size="small"
                                                        label={(event.data[field.order] === 1) ? infield.on : infield.off} />

                                                )
                                            )}
                                        </Grid>


                                    </Grid>

                                ) : (<div></div>)
                            ))
                        ))}

                        {instrument.inputfields.map((infield, index) => (
                            message.inputs.map((field) => (
                                (field.order === infield.fieldindex && (index >= instrument.outputfields.length)) ? (
                                    (
                                        <Grid item xs="auto">
                                            <div>&nbsp;</div>
                                        </Grid>
                                    )
                                ) : (<div></div>)
                            ))
                        ))}
                    </Grid>
                </Grid>

            </Box>
        </Fragment >
    );

}

export default INST08;